module.exports = __webpack_public_path__ + "static/media/carousel_logo2.593d80f3.png";